import React from 'react';

const AwardsForm = () => {
    return <></>;
};

export default AwardsForm;
